import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Grid from '@material-ui/core/Grid';

// Project
import { selectState, actionProps } from 'utils/reduxActions';
import { ReactReduxContext } from 'config/configureStore';
import connectSaga from 'utils/saga';
import saga from './saga';

import { clone, truthty, falsy } from 'utils/functions';
import { Container, withStyles } from '@material-ui/core';
import carriers, { carriersActions } from './reducer';

import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import CardHeader from '@material-ui/core/CardHeader';
import Menu from '@material-ui/core/Menu';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
// styles
import styles from './styles';
import CarrierForm from './components/CarrierForm';
import DeleteModal from 'commons/components/DeleteModal';
import MaintainersPaginator from 'commons/components/MaintainersPaginator';

const useStyles = makeStyles(styles);

function Carriers(props) {
  const { t } = useTranslation();
  const { objects, formIsOpen, formControls, edit, invalidControls, deleteIsOpen, actions } = props;
  const [carrierList, setCarrierList] = useState([]);
  const [filter, setFilter] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);


  useEffect(() => {
    setCarrierList(
      Object.values(objects.carriers).filter((item) =>
        item.name.toLowerCase().includes(filter.toLowerCase()),
      ),
    );
  }, [objects.carriers, filter]);

  useEffect(() => {
    actions.getStateFromApi();
  }, [actions]);

  function handleClick(event) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  function toggleForm() {
    actions.toggleForm('formIsOpen');
  }

  function closeForm() {
    actions.toggleForm('deleteIsOpen');
  }

  function toggleDelete() {
    handleClose();
    actions.toggleDelete(anchorEl.dataset.id);
  }

  function toggleEdit() {
    handleClose();
    const item = Object.values(objects.carriers).find(
      (item) => item.id === Number(anchorEl.dataset.id),
    );
    actions.toggleEdit(item);
  }
  
  function changeControls(event) {
    actions.changeControls(
      { [event.currentTarget.id]: event.target.value },
      { [event.currentTarget.id]: false },
    );
  }

  function submit() {
    if (falsy(formControls.name)) {
      actions.setInvalidControls({
        name: falsy(formControls.name),
      });
    } else if (edit) {
      actions.editCarrier(props.toEditId, formControls);
    } else {
      actions.createCarrier(formControls);
    }
  }

  function submitDelete() {
    actions.deleteCarrier(props.toDeleteId);
  }

  function onFilterChange(event) {
    setFilter(event.target.value);
  }

  const classes = useStyles();

  const getListItem = (
    carriers,
    openMenuHandler,
  ) => (
    <ListItem key={`carrier-${carriers.id}`}>
      <ListItemAvatar>
        <Avatar className={classes.blue}>{(carriers.name || 'p')[0].toUpperCase()}</Avatar>
      </ListItemAvatar>
      <ListItemText primary={carriers.name} />
      <ListItemSecondaryAction>
        <IconButton
          data-id={carriers.id}
          onClick={openMenuHandler}
          aria-controls={`menu-carrier-${carriers.id}`}>
          <MoreVertIcon />
        </IconButton>
      </ListItemSecondaryAction>
    </ListItem>
  );

  return (
    <Container maxWidth={false}>
      <Grid container spacing={3} className={classes.container}>
        <Grid item xs={12}>
          <Typography variant="h3" component="h2" className={classes.marginTop}>
            {t('Carriers')}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Card className={classes.root}>
            <CardHeader title={t('Filter')} />
            <CardContent>
              <Grid container spacing={3} className={classes.container}>
                <Grid container item xs={4}>
                  <TextField
                    fullWidth
                    id="standard-basic"
                    label={t('Name')}
                    value={filter}
                    onChange={onFilterChange}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12}>
          <Card className={classes.root}>
            <CardContent>
              {truthty(objects.carriers) ? (
                <MaintainersPaginator
                  classes={classes}
                  list={carrierList}
                  getListItem={getListItem}
                  openMenuHandler={handleClick}
                  closeMenuHandler={handleClose}
                  toggleEdit={toggleEdit}
                  toggleDelete={toggleDelete}
                />
              ) : (
                <Grid container item xs={12} alignItems="center" justifyContent="center">
                  <Typography variant="h6" component="h2">
                    {t('No carriers found')}
                  </Typography>
                </Grid>
              )}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <CarrierForm
        isOpen={formIsOpen}
        toggleForm={toggleForm}
        changeControls={changeControls}
        controls={formControls}
        units={objects.units}
        edit={edit}
        submit={submit}
        invalidControls={invalidControls}
      />
      <DeleteModal
        isOpen={deleteIsOpen}
        toggleForm={closeForm}
        submit={submitDelete}
        buttonId="delete-carrier"
      />
      <Fab color="primary" aria-label="add" className={classes.fab} onClick={toggleForm}>
        <AddIcon />
      </Fab>
      <Menu
        id="menu-carriers"
        anchorEl={anchorEl}
        keepMounted
        open={truthty(anchorEl)}
        onClose={handleClose}>
        <MenuItem onClick={toggleEdit}>
          <ListItemIcon>
            <EditIcon />
          </ListItemIcon>
          {t('Edit')}
        </MenuItem>
        <MenuItem onClick={toggleDelete}>
          <ListItemIcon>
            <DeleteIcon />
          </ListItemIcon>
          {t('Delete')}
        </MenuItem>
      </Menu>
    </Container>
  );
}

const withSaga = connectSaga({ key: 'sagaCarriers', saga });

const withConnect = connect(
  selectState(
    'carriers.invalidControls',
    'carriers.formControls',
    'carriers.deleteIsOpen',
    'carriers.toDeleteId',
    'carriers.formIsOpen',
    'carriers.toEditId',
    'carriers.edit',
    'app.objects',
  ),
  actionProps(clone(clone.OBJECT, carriersActions)),
  null,
  { context: ReactReduxContext },
);

export default compose(withStyles(styles), withRouter, withConnect)(withSaga(Carriers));